import { render, staticRenderFns } from "./Leg.vue?vue&type=template&id=0877fb9f&scoped=true&"
import script from "./Leg.vue?vue&type=script&lang=js&"
export * from "./Leg.vue?vue&type=script&lang=js&"
import style0 from "./Leg.vue?vue&type=style&index=0&id=0877fb9f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0877fb9f",
  null
  
)

/* custom blocks */
import block0 from "./Leg.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports